import { Component, Host, h } from '@stencil/core';

@Component({
  tag: 'spw-accordion',
  styleUrl: 'spw-accordion.scss',
  shadow: true,
})
export class SpwAccordion {
  render() {
    return (
      <Host>
        <div class="spw-accordion">
          <slot></slot>
        </div>
      </Host>
    );
  }
}
